module.exports = __webpack_public_path__ + "img/cloud-off.75571ba2.svg";